var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _g, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _circle3, _circle4, _path7, _circle5, _circle6, _path8, _circle7, _circle8, _path9, _circle9, _circle10, _path10, _circle11, _circle12, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.028,
    x2: 213.085,
    xlinkHref: "#lg1",
    y1: 213.005,
    y2: 302.069
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.334,
    x2: -108.74,
    xlinkHref: "#lg2",
    y1: 243.073,
    y2: 117.574
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.569,
    x2: 281.553,
    y1: 316.579,
    y2: 262.563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.063,
    x2: 289.667,
    xlinkHref: "#lg1",
    y1: 231.194,
    y2: 306.088
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.016,
    x2: 164.445,
    xlinkHref: "#lg2",
    y1: 343.27,
    y2: 0.173
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1511.468,
    x2: 1562.415,
    xlinkHref: "#lg3",
    y1: -519.607,
    y2: -468.659
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1530.905,
    x2: 1506.634,
    xlinkHref: "#lg4",
    y1: -498.197,
    y2: -532.607
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1527.552,
    x2: 1581.623,
    xlinkHref: "#lg5",
    y1: -489.812,
    y2: -590.376
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1495.833,
    x2: 1546.78,
    xlinkHref: "#lg3",
    y1: -263.905,
    y2: -212.957
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1515.27,
    x2: 1490.999,
    xlinkHref: "#lg4",
    y1: -242.496,
    y2: -276.905
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -1351.363 226.771)",
    gradientUnits: "userSpaceOnUse",
    x1: 1511.917,
    x2: 1565.988,
    xlinkHref: "#lg5",
    y1: -234.111,
    y2: -334.674
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.308,
    x2: 381.256,
    xlinkHref: "#lg6",
    y1: 88.138,
    y2: 139.085
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.746,
    x2: 325.475,
    xlinkHref: "#lg7",
    y1: 109.547,
    y2: 75.137
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.392,
    x2: 400.463,
    xlinkHref: "#lg8",
    y1: 117.932,
    y2: 17.368
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.308,
    x2: 381.256,
    xlinkHref: "#lg6",
    y1: 455.945,
    y2: 506.893
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.746,
    x2: 325.475,
    xlinkHref: "#lg7",
    y1: 477.354,
    y2: 442.945
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.392,
    x2: 400.463,
    xlinkHref: "#lg8",
    y1: 485.739,
    y2: 385.175
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.091,
    x2: 197.038,
    xlinkHref: "#lg9",
    y1: 25.599,
    y2: 76.547
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.529,
    x2: 141.257,
    xlinkHref: "#lg10",
    y1: 47.009,
    y2: 12.599
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg11"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.175,
    x2: 216.246,
    xlinkHref: "#lg11",
    y1: 55.393,
    y2: -45.171
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.364,
    x2: 298.311,
    xlinkHref: "#lg9",
    y1: 331.107,
    y2: 382.055
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.802,
    x2: 242.53,
    xlinkHref: "#lg10",
    y1: 352.516,
    y2: 318.107
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.448,
    x2: 317.519,
    xlinkHref: "#lg11",
    y1: 360.901,
    y2: 260.337
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7e8595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.56 34.756h352.881v11.122h-352.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.56 97.294h352.881v11.122h-352.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.638 159.833h258.725v11.122h-258.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.56 463.684h352.881v11.122h-352.881z",
    transform: "matrix(-1 0 0 -1 510.001 938.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.56 401.145h352.881v11.122h-352.881z",
    transform: "matrix(-1 0 0 -1 510.001 813.413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.638 338.607h258.725v11.122h-258.725z",
    transform: "matrix(-1 0 0 -1 510.001 688.336)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m442.236 509.561c-12.577 0-22.772-10.195-22.772-22.772 0-30.599-7.775-60.955-22.487-87.785-14.711-26.83-36.124-49.708-61.923-66.161l-184.598-117.725c-32.234-20.557-58.987-49.143-77.367-82.665s-28.097-71.45-28.097-109.681c0-12.577 10.195-22.772 22.772-22.772s22.772 10.195 22.772 22.772c0 30.599 7.775 60.955 22.487 87.785 14.711 26.83 36.123 49.708 61.922 66.161l184.597 117.725c32.234 20.557 58.988 49.143 77.368 82.665s28.096 71.45 28.096 109.681c.002 12.577-10.193 22.772-22.77 22.772z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m436.911 377.108c-18.381-33.522-45.135-62.108-77.368-82.665l-184.597-117.725c-25.799-16.453-47.211-39.331-61.922-66.161-14.712-26.83-22.487-57.186-22.487-87.785 0-9.32-5.601-17.328-13.619-20.852-8.018 3.525-13.619 11.532-13.619 20.852 0 38.231 9.716 76.159 28.096 109.681s45.134 62.108 77.367 82.665l184.597 117.725c25.799 16.453 47.212 39.331 61.923 66.161 14.712 26.83 22.487 57.186 22.487 87.785 0 9.32 5.602 17.328 13.619 20.852 8.018-3.525 13.619-11.532 13.619-20.852.001-38.231-9.715-76.158-28.096-109.681z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m359.543 294.443-82.725-52.757-43.606 26.209 101.842 64.949c10.263 6.545 19.817 14.122 28.546 22.544h59.719c-17.064-24.183-38.759-44.99-63.776-60.945z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m67.764 509.561c-12.577 0-22.772-10.195-22.772-22.772 0-38.231 9.716-76.159 28.096-109.681s45.134-62.108 77.367-82.665l184.597-117.725c25.799-16.453 47.212-39.331 61.923-66.161 14.712-26.83 22.487-57.186 22.487-87.785.002-12.577 10.197-22.772 22.774-22.772s22.772 10.195 22.772 22.772c0 38.231-9.716 76.159-28.096 109.681s-45.135 62.108-77.368 82.665l-184.598 117.725c-25.799 16.452-47.211 39.331-61.922 66.161-14.712 26.83-22.487 57.186-22.487 87.785-.001 12.577-10.196 22.772-22.773 22.772z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m174.946 332.843 184.597-117.725c32.234-20.557 58.988-49.143 77.368-82.665s28.096-71.45 28.096-109.681c0-10.104-6.582-18.665-15.69-21.643-9.108 2.978-15.69 11.54-15.69 21.643 0 30.599-7.775 60.955-22.487 87.785-14.711 26.83-36.124 49.708-61.923 66.161l-184.597 117.725c-32.234 20.557-58.987 49.143-77.367 82.665s-28.096 71.45-28.096 109.681c0 10.104 6.582 18.665 15.69 21.643 9.108-2.978 15.69-11.54 15.69-21.643 0-30.599 7.775-60.955 22.487-87.785 14.711-26.83 36.122-49.708 61.922-66.161z",
    fill: "url(#SVGID_5_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.001,
    cy: 165.394,
    fill: "url(#SVGID_6_)",
    r: 39.337
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.001,
    cy: 165.394,
    fill: "url(#SVGID_7_)",
    r: 32.83
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m281.673 136.473c1.079 5.823.857 11.979-.899 18.057-6.03 20.871-27.838 32.903-48.71 26.872-6.077-1.756-11.403-4.851-15.754-8.87 2.627 14.177 12.977 26.379 27.771 30.653 20.872 6.03 42.68-6.001 48.71-26.872 4.275-14.794-.527-30.057-11.118-39.84z",
    fill: "url(#SVGID_8_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.997,
    cy: 406.706,
    fill: "url(#SVGID_9_)",
    r: 39.337
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.997,
    cy: 406.706,
    fill: "url(#SVGID_10_)",
    r: 32.83
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m195.67 377.785c1.079 5.823.857 11.979-.899 18.057-6.03 20.871-27.838 32.903-48.71 26.872-6.077-1.756-11.403-4.851-15.754-8.87 2.627 14.177 12.977 26.379 27.771 30.653 20.872 6.03 42.68-6.001 48.71-26.872 4.275-14.794-.527-30.057-11.118-39.84z",
    fill: "url(#SVGID_11_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.026,
    cy: 102.856,
    fill: "url(#SVGID_12_)",
    r: 39.337
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.026,
    cy: 102.856,
    fill: "url(#SVGID_13_)",
    r: 32.83
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m362.623 67.667c2.653 5.295 4.149 11.271 4.149 17.597 0 21.725-17.612 39.337-39.337 39.337-6.326 0-12.302-1.495-17.597-4.149 6.459 12.89 19.789 21.74 35.188 21.74 21.725 0 39.337-17.612 39.337-39.337 0-15.399-8.85-28.729-21.74-35.188z",
    fill: "url(#SVGID_14_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.026,
    cy: 470.663,
    fill: "url(#SVGID_15_)",
    r: 39.337
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.026,
    cy: 470.663,
    fill: "url(#SVGID_16_)",
    r: 32.83
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m362.623 435.475c2.653 5.295 4.149 11.271 4.149 17.597 0 21.725-17.612 39.337-39.337 39.337-6.326 0-12.302-1.495-17.597-4.149 6.459 12.89 19.789 21.74 35.188 21.74 21.725 0 39.337-17.612 39.337-39.337 0-15.399-8.85-28.73-21.74-35.188z",
    fill: "url(#SVGID_17_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.809,
    cy: 40.317,
    fill: "url(#SVGID_18_)",
    r: 39.337
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.809,
    cy: 40.317,
    fill: "url(#SVGID_19_)",
    r: 32.83
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m178.405 5.129c2.653 5.295 4.149 11.271 4.149 17.597 0 21.725-17.612 39.337-39.337 39.337-6.326 0-12.302-1.495-17.597-4.149 6.459 12.89 19.789 21.74 35.188 21.74 21.725 0 39.337-17.612 39.337-39.337.001-15.399-8.849-28.729-21.74-35.188z",
    fill: "url(#SVGID_20_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.082,
    cy: 345.825,
    fill: "url(#SVGID_21_)",
    r: 39.337
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.082,
    cy: 345.825,
    fill: "url(#SVGID_22_)",
    r: 32.83
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m279.678 310.637c2.653 5.295 4.149 11.271 4.149 17.597 0 21.725-17.612 39.337-39.337 39.337-6.326 0-12.302-1.495-17.597-4.149 6.459 12.89 19.789 21.74 35.188 21.74 21.725 0 39.337-17.612 39.337-39.337.001-15.399-8.849-28.73-21.74-35.188z",
    fill: "url(#SVGID_23_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDna);
export default __webpack_public_path__ + "static/media/icon-dna.453b039bd1c32a0e4a30ae1fd194c0ee.svg";
export { ForwardRef as ReactComponent };